export default __webpack_public_path__ + "static/media/feat-icon3.e1f1d8b5.svg";